let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dB2iT")).then(() => parcelRequire('hJ1K1'));